import * as angular from "angular";
import { IController } from "angular";
import { TimecardShellContext } from "../../angular/models/timecard-detail.model";

/**
 * AngularJS shell of the timecard detail. The screen itself is the Angular <app-timecard-detail>; this shell
 * only hosts the widgets that have no Angular version yet (agent select, agent-performance-map,
 * agents-performance-timeline) and projects them into it.
 */
export class TimecardDetailViewCtrl implements IController {

  agentId: string;
  fromDate: number;
  toDate: number;
  isAgentView?: boolean;
  listFrom?: number;
  listTo?: number;
  groupTags?: string[];
  groupIds?: string[];
  branchIds?: string[];
  tags?: string[];
  statuses?: string[];
  displayStatusGroups?: string[];
  queryString?: string;

  context: TimecardShellContext;
  highlightedTaskId: string;
  timelineTimestamp: number;

  readonly taskTooltipTemplateUrl = 'app/modules/timekeeping/components/timecard-detail-view/timecard-task-tooltip.html';

  /* @ngInject */
  constructor(private $state, private $scope) {
  }

  // Angular outputs run outside the AngularJS digest
  onContextChange(context: TimecardShellContext) {
    this.context = context;
    this.$scope.$applyAsync();
  }

  onSelectAgent(agent: { id?: string }) {
    if (agent?.id && agent.id !== this.agentId) {
      this.$state.go('timecardDetail', {
        agentId: agent.id,
        from: this.context?.fromDate,
        to: this.context?.toDate
      }, {
        reload: true
      });
    }
  }

  onHighlightedChanged(taskId: string) {
    this.highlightedTaskId = taskId;
  }

  onTimelineTimestampChange(timestamp: number) {
    this.timelineTimestamp = timestamp;
  }
}

angular
  .module('bringoz.admin.timekeeping')
  .component('timecardDetailView', {
    bindings: {
      agentId: '<?',
      fromDate: '<?',
      toDate: '<?',
      isAgentView: '<?',
      listFrom: '<?',
      listTo: '<?',
      groupTags: '<?',
      groupIds: '<?',
      branchIds: '<?',
      tags: '<?',
      statuses: '<?',
      displayStatusGroups: '<?',
      queryString: '<?'
    },
    template: require('./timecard-detail-view.html').default,
    controller: TimecardDetailViewCtrl
  });
